// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"zs-z","imageAndVideoCount":"As-z","imageAndVideoContainer":"Bs-z","viewAllReviews":"Cs-z"};